import React from 'react';
import imagePlaceholder from '../../../../images/tv-placeholder-landscape.png';
import { classes } from '../../../../utils/commonUtils';
import './style.scss';

export interface PlayerInfoPopupProps {
  title: string;
  subtitle: string;
  image: string;
  buttonLabel: string;
  onClick: () => void;
  onCancel: () => void;
  hide?: boolean;
}

export function PlayerInfoPopup({
  title,
  subtitle,
  image,
  buttonLabel,
  onClick,
  onCancel,
  hide = false,
}: PlayerInfoPopupProps) {
  const classname = classes('player-info-popup', hide && 'hidden');

  return (
    <div className={classname}>
      <button className="aib-icon crossout" aria-label="Close">
        <span role="button" onClick={() => onCancel()}>
          B
        </span>
      </button>
      <div className="poster-image">
        <div className="overlay" onClick={() => onClick()} role="button">
          <div className="icon">
            <span className="aib-icon">Ă</span>
          </div>
        </div>
        <img src={image} onError={(e) => (e.currentTarget.src = imagePlaceholder)} alt={subtitle} />
      </div>
      <div className="content">
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <div className="description" dangerouslySetInnerHTML={{ __html: subtitle }} />
        <button className="autoplay-action" onClick={() => onClick()} aria-label="Go to next episode">
          <span className="autoplay-container">
            <span className="icon">
              <span className="aib-icon">z</span>
            </span>
            <span className="text">{buttonLabel}</span>
          </span>
        </button>
      </div>
    </div>
  );
}

export default PlayerInfoPopup;
